module.exports = __webpack_public_path__ + "images/favicon-76cee8a184f40fb1029b08ee131e4f07.ico";